// extracted by mini-css-extract-plugin
module.exports = {"container":"EmailSignupBanner_container__wSXvT","privacyPolicy":"EmailSignupBanner_privacyPolicy__96Wwn"};